<div id="affiliation" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Affiliation University</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College, Sirsa is affiliated to <strong>Chaudhary Devi Lal University (CDLU),
        Sirsa</strong>, Haryana. The college operates under the guidelines and regulations of CDLU and the University
      Grants Commission (UGC), Government of India.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Affiliation Document</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/hei/affiliation-university/Affiliation%20University%202026.pdf" [render-text]="true"
        [original-size]="false" style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-4 d-flex flex-wrap gap-3">
      <a href="/assets/pdf/hei/affiliation-university/Affiliation%20University%202026.pdf" target="_blank"
        class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Affiliation Document (2026)
      </a>
      <a href="/assets/pdf/hei/affiliation-university/Affiliation%20University%202024.pdf" target="_blank"
        class="pdf-download-btn outline-btn">
        <i class="fa fa-download"></i> Download Affiliation Document (2024)
      </a>
    </div>

  </div>
</div>